module.exports = __webpack_public_path__ + "static/flags/BE-c1976db9bfbe81b82a95d180dbcc8c8a.gif";